export default __webpack_public_path__ + "static/media/ILUSTRACIONES_13.59dca835.png";